import i18next from "i18next";

import Norwegian from "./translations/Norwegian";
import Swedish from "./translations/Swedish";
import Danish from "./translations/Danish";
import English from "./translations/English";
import Config from "./Config";

i18next.init({
    lng: Config.language,
    debug: true,
    resources: {
        en: {translation: English},
        no: {translation: Norwegian},
        se: {translation: Swedish},
        dk: {translation: Danish},
    },
    interpolation: {
        // Disable converting "'" into &#39; - it creates bugs and react does it for us
        escapeValue: false
    },
    function (err, t) {
        console.log("i18n: " + err + " " + t);
    }
});

export default i18next;



// WEBPACK FOOTER //
// ./src/js/include/Translations.js